<template>
    <div class="col-md-12 mx-auto">
        <div class="card mt-12">
            <div class="card-header bg-primary text-white">
                <page-title :title="pageTitle"></page-title>
            </div>

            <div v-if="isFormDetails || isAuxRegisterDetails" class="btn-toolbar justify-content-between mt-3" role="toolbar">
                <div class="form-inline col-lg-6 col-md-12">

                </div>

                <div class="input-group col-lg-6 col-md-12">
                    <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary"
                            @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>


            <div class="card-body">
                <!-- Datasource на родителските номенклатури -->
                <!-- requestEnd="datasorceRequestEnd" се извиква след края на всяка заявка на сорса -->
                <!-- error="dataSourceError" се извиква след грешка на заявка на сорса -->
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd">
                </kendo-datasource>

                <!-- Грид на родителските номенклатури -->
                <!-- v-on:detailinit="detailInit" ще вмъкне грид в дадения ред  -->
                <!-- v-on:databound="dataBound"" се грижи за горното  -->
                <kendo-grid ref="fieldDetailsGrid"
                            data-source-ref="datasource1"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :editable="gridOptions.editable"
                            v-on:detailinit="detailInit"
                            :data-bound="dataBound">
                    <kendo-grid-column :field="'name'"
                                       :title="$t('registers.dynamic.gridHeaders.name')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'nameEn'"
                                       :title="$t('registers.dynamic.gridHeaders.nameEn')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'active'"
                                       :title="$t('registers.dynamic.gridHeaders.active')"
                                       :template="activeCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column v-if="showCreateUpdateInfoColumns"
                                       :field="'createdAt'"
                                       :title="$t('createdOn')"
                                       :width="150"
                                       :format="customDateTimeLongFormat">
                    </kendo-grid-column>
                    <kendo-grid-column v-if="showCreateUpdateInfoColumns"
                                       :field="'creatorUsername'"
                                       :title="$t('createdBy')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column v-if="showCreateUpdateInfoColumns"
                                       :field="'updatedAt'"
                                       :title="$t('lastUpdatedOn')"
                                       :width="150"
                                       :format="customDateTimeLongFormat">
                    </kendo-grid-column>
                    <kendo-grid-column v-if="showCreateUpdateInfoColumns"
                                       :field="'updaterUsername'"
                                       :title="$t('lastUpdatedBy')"
                                       :width="150">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'; // това се изисква за да се вмъкват kendo ui компоненти. Виж метод parentIdDropDownEditor
    import GridUserSettings from "../../../components/grid/UserSettings";
    import PageTitle from '../../../components/common/PageTitle';
    import { mapGetters } from 'vuex'

    export default {
        components: {
            PageTitle,
            'grid-user-settings': GridUserSettings
        },
        props: {
            fieldDetailsType: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                componentName: `${this.fieldDetailsType}_inactiveFildsGrid`, // Трабва на конпонентата за бутоните за дашборд настройките
                searchQuery: '',
                defaultGridRows: this.$store.getters.defaultGridRows,
                schemaModelFields: {
                    id: {
                        name: 'id',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.dynamic.gridHeaders.id'
                    },
                    name: {
                        name: 'name',
                        type: 'string',
                        validation: { required: true },
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.dynamic.gridHeaders.name'
                    },
                    nameEn: {
                        name: 'nameEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.dynamic.gridHeaders.nameEn'
                    },
                    deactivated: {
                        name: 'deactivated',
                        type: 'boolean',
                        editable: false,
                        nullable: true,
                        visible: false,
                        titleKey: 'registers.dynamic.gridHeaders.deactivated'
                    },
                    active: {
                        name: 'active',
                        type: 'boolean',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.dynamic.gridHeaders.active'
                    },
                    creatorUsername: { name: 'creatorUsername', type: 'string', editable: false, nullable: true, visible: true },
                    createdAt: { name: 'createdAt', type: 'date', editable: false, nullable: true, visible: true },
                    updaterUsername: { name: 'updaterUsername', type: 'string', editable: false, nullable: true, visible: true },
                    updatedAt: { name: 'updatedAt', type: 'date', editable: false, nullable: true, visible: true },
                },
                childrenSchemaModelFields: {
                    id: {
                        name: 'id',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.id'
                    },
                    registerId: { name: 'registerId', type: 'number', editable: false, visible: false },
                    registerName: {
                        name: 'registerName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.name'
                    },
                    registerNameEn: {
                        name: 'registerNameEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.nameEn'
                    },
                    isPanel: { name: 'isPanel', type: 'boolean' },
                    type: {
                        name: 'type',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.name'
                    },
                    typeEn: {
                        name: 'typeEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.nameEn'
                    },
                    name: {
                        name: 'name',
                        type: 'string',
                        editable: true,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.name',
                        validation: { required: true }
                    },
                    nameEn: {
                        name: 'nameEn',
                        type: 'string',
                        editable: true,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.nameEn'
                    },
                    label: {
                        name: 'label',
                        type: 'string',
                        editable: true,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.name',
                        validation: { required: true }
                    },
                    labelEn: {
                        name: 'labelEn',
                        type: 'string',
                        editable: true,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.nameEn'
                    },
                    active: {
                        name: 'active',
                        type: 'boolean',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.active',
                        defaultValue: true
                    },
                    locked: {
                        name: 'locked',
                        type: 'boolean',
                        editable: true,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.nomenclatures.gridHeaders.locked',
                        defaultValue: false
                    },
                    deactivated: {
                        name: 'deactivated',
                        type: 'boolean',
                        editable: true,
                        nullable: false,
                        visible: false,
                        titleKey: 'registers.nomenclatures.gridHeaders.deactivated',
                        validation: { required: false },
                        defaultValue: false
                    },
                },
                working: false,
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    editable: {
                        mode: 'popup',
                        window: {
                            title: "Поле",
                            animation: true,
                        }
                    }
                },
            };
        },
        methods: {
            dataBound(ev) {
                ev.sender.expandRow(ev.sender.tbody.find('tr.k-master-row').first())
            },
            parameterMap(options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                    // options. Така се предава информация за take, skip , page и списък с обекти
                    // описващи сортирането
                    return kendo.stringify(options);
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                })
            },
            beforeSend(req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            datasorceRequestEnd(e) {
                if (e.type === "create" && e.response) {
                    e.sender.read()

                    this.$vs.notify({
                        title: '',
                        text: e.response && e.response.message ? e.response.message : this.$t('createSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                } else if (e.type === "update" && e.response) {
                    e.sender.read()

                    this.$vs.notify({
                        title: '',
                        text: e.response && e.response.message ? e.response.message : this.$t('updateSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }
            },
            detailInit: function (e) {
                $('<div />').appendTo(e.detailCell).kendoGrid({
                    dataSource: {
                        transport: this.detailGridTransportSettings,
                        serverPaging: true,
                        serverSorting: true,
                        serverFiltering: true,
                        pageSize: this.defaultGridRows,
                        filter: { // това филтрира само елементите за дадена родителска категория
                            field: 'registerId',
                            operator: 'eq',
                            value: e.data.id
                        },
                        schema: {
                            model: {
                                id: 'id',
                                fields: this.childrenSchemaModelFields
                            },
                            total: 'total',
                            data: 'data'
                        },
                        requestEnd: this.datasorceRequestEnd,
                        error: this.dataSourceError
                    },
                    editable: this.gridOptions.editable,
                    navigatable: this.gridOptions.navigatable,
                    filterable: this.gridOptions.filterable,
                    pageable: this.gridOptions.pageable,
                    reorderable: this.gridOptions.reorderable,
                    resizable: this.gridOptions.resizable,
                    groupable: this.gridOptions.groupable,
                    selectable: this.gridOptions.selectable,
                    scrollable: this.gridOptions.scrollable,
                    allowCopy: this.gridOptions.allowCopy,
                    columnMenu: this.gridOptions.columnMenu,
                    sortable: {
                        mode: this.gridOptions.sortable.mode,
                        allowUnsort: this.gridOptions.sortable.allowUnsort,
                        showIndexes: this.gridOptions.sortable.showIndexes
                    },
                    columns: [{
                        field: 'id',
                        title: this.$t('registers.nomenclatures.gridHeaders.id'),
                        hidden: true
                    },
                        {
                            field: this.isEnVersion ? 'registerNameEn' : 'registerName',
                            title: this.$t('editor.dropdown.register'),
                        },
                        {
                            field: this.isEnVersion ? 'typeEn' : 'type',
                            title: this.$t('editor.common.type'),
                        },
                        {
                            field: 'name',
                            title: this.$t('registers.nomenclatures.gridHeaders.name')
                        },
                        {
                            field: 'nameEn',
                            title: this.$t('registers.nomenclatures.gridHeaders.nameEn')
                        },
                        {
                            field: 'label',
                            title: this.$t('editor.common.label')
                        },
                        {
                            field: 'labelEn',
                            title: this.$t('editor.common.labelEn')
                        },
                        {
                            field: 'deactivated',
                            title: this.$t('registers.nomenclatures.gridHeaders.deactivated'),
                            hidden: true
                        },
                        {
                            field: 'active',
                            title: this.$t('registers.dynamic.gridHeaders.active'),
                            template: this.activeCellTemplate
                        },
                        {
                            field: 'locked',
                            title: this.$t('registers.dynamic.gridHeaders.locked'),
                            template: this.lockedCellTemplate
                        },
                        {
                            command: this.command,
                            title: this.$t('actions')
                        }]
                })
            },
            activeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            lockedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.locked ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.locked ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.fieldDetailsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.fieldDetailsGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
        },
        mounted: function () {
        },
        computed: {
            ...mapGetters(['isEnVersion', 'claims', 'dateTimeLongFormat']),
            customDateTimeLongFormat() {
                return `{0: ${this.dateTimeLongFormat} }`;
            },
            token() {
                return this.$store.getters.authToken;
            },
            hasEditRights() {
                return this.claims.dynamicRegister.create
                    || this.claims.dynamicRegister.update;
            },
            command() {
                let cmd = [];
                if (this.hasEditRights) {
                    cmd.push({ name: 'edit', text: this.$t('buttons.edit.btnText') });
                }
                return cmd;
            },
            isFormDetails() {
                return this.fieldDetailsType && this.fieldDetailsType === 'forms';
            },
            isAuxRegisterDetails() {
                return this.fieldDetailsType && this.fieldDetailsType === 'auxiliaryRegisters';
            },
            pageTitle() {
                return (this.isFormDetails
                    ? this.$t('sideMenu.forms')
                    : (this.isAuxRegisterDetails
                        ? this.$t('sideMenu.auxiliaryRegister')
                        : this.$t('registers.dynamic.title')))
                    + ' ' + this.$t('sideMenu.panelsFields')
            },
            backendControllerName() {
                return this.isFormDetails
                    ? 'dynamicForms'
                    : (this.isAuxRegisterDetails
                        ? 'auxiliaryRegisters'
                        : 'dynamicRegisters');
            },
            transportSettings() {
                return {
                    read: {
                        url: `${this.$store.getters.baseUrl}/api/${this.backendControllerName}/list`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                }
            },
            detailGridTransportSettings() {
                return {
                    read: {
                        url: `${this.$store.getters.baseUrl}/api/${this.backendControllerName}/listFields`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    update: {
                        url: `${this.$store.getters.baseUrl}/api/${this.backendControllerName}/updateComponent`,
                        dataType: 'json',
                        type: 'PATCH',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap,
                }
            },
            showCreateUpdateInfoColumns() {
                return this.isFormDetails || this.isAuxRegisterDetails;
            },
        }
    }
</script>

<style scoped>
</style>
